// extracted by mini-css-extract-plugin
module.exports = {"announcement":"announcement-Ayd9o"};